module.exports = __webpack_public_path__ + "static/media/kinamoua.8174645d.jpg";